module.exports = __webpack_public_path__ + "static/media/edit-regular.85f5eb7f.svg";